<template>
  <div>This is article page</div>
</template>

<script>
export default {
  name: 'article'
}
</script>
